<template> 
        <footer class="footer">
        <div class="container">
            <div class="row">
                <div class="col-12">
                    <div class="footer-top">
                        <div class="row">
                            <div class="col-sm-4">
                                <div class="footer-div">
                                    <h4>Što je figaro.hr?</h4>
                                    <p>Figaro.hr je platforma za naručivanje termina u salonima za zdravlje i ljepotu. <a href="/cesta-pitanja">Pročitaj više.</a></p>
                                </div>
                            </div>
                            <div class="col-sm-4">
                                <div class="footer-div">
                                    <h4>Kako rezervirati termin?</h4>
                                    <p>U samo par klikova! Naručivanje termina online jednostavno je, brzo i pouzdano. <a href="/kako-rezervirati">Pročitaj više.</a></p>
                                </div>
                            </div>
                            <div class="col-sm-4">
                                <div class="footer-div">
                                    <h4>Za salone</h4>
                                    <p>Naši korisnici prije svega traže kvalitetnu ali i povoljnu uslugu. <a href="/business">Započnimo suradnju.</a></p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="col-12">
                    <div class="footer-bottom">
                        <ul class="nav">
                            <li class="nav-item">
                                <a class="nav-link active" href="/">Početna</a>
                            </li>
                            <li class="nav-item">
                                <a class="nav-link active" href="/kako-rezervirati">Kako rezervirati</a>
                            </li>
                            <li class="nav-item">
                                <a class="nav-link" href="/cesta-pitanja">Česta pitanja</a>
                            </li>
                            <li class="nav-item">
                                <a class="nav-link" href="/business">Za salone</a>
                            </li>
                            <li class="nav-item">
                                <a class="nav-link" href="/uvjeti">Uvjeti korištenja</a>
                            </li>
                            <li class="nav-item">
                                <a class="nav-link" href="/privatnost">Privatnost</a>
                            </li>
                            <li class="nav-item">
                                <a class="nav-link" href="/kontakt">Kontakt</a>
                            </li>
                        </ul>
                        <div id="copyright">
                            <p>Figaro.hr &copy;
                                2020
                            </p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
         <div class="alert text-center cookiealert" role="alert">
            <div class="container">U skladu s novom europskom regulativom, izradili smo Pravila zaštite privatnosti.
                Naša web stranica, kao i alati za analizu korištenja naših web stranica, koriste kolačiće koji se spremaju u Vaš preglednik. Za više detalja
                <a href="../izjava-o-privatnosti.php">kliknite ovdje</a>.<button type="button" class="btn fs-btn small dark acceptcookies m-1" aria-label="Close">RAZUMIJEM</button>
            </div>
        </div>
    </footer>  
</template>

<script>
export default {
    name:'footer'
}
</script>